import { ApolloError } from '@apollo/client'
import { css } from '@emotion/react'
import { Button, Flow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import {
  Form,
  PecFormApi,
  SubmitButton,
  TextAreaField,
  TextField,
  VisibilidadePoligonoTerritorioSelectField,
} from 'components/form'
import { useSalvarPoligonoTerritorioMutation } from 'graphql/hooks.generated'
import { metaPath } from 'util/metaPath'

import { TerritorioMapaCamadasFormModel } from '../model-territorioMapaCamadas'
import { validateTerritorioMapaCamadasForm } from '../validator-territorioMapaCamadas'

const meta = metaPath<TerritorioMapaCamadasFormModel>()

interface TerritorioMapaCamadasFormProps {
  onCancel: () => void
  refetch: () => void
}

export function TerritorioMapaCamadasForm(props: Readonly<TerritorioMapaCamadasFormProps>) {
  const { refetch, onCancel } = props

  const alert = useAlert()

  const [salvarPoligonoTerritorio] = useSalvarPoligonoTerritorioMutation()
  const handleRejection = useErrorHandler()

  const handleSubmit = async (values: TerritorioMapaCamadasFormModel) => {
    try {
      await salvarPoligonoTerritorio({
        variables: {
          input: {
            nome: values.nome,
            descricao: values.descricao,
            visibilidade: values.visibilidade,
            geoJson:
              '{"type":"FeatureCollection","name":"dawdw","bbox":[-48.567086,-27.622952,-48.523846,-27.576918],"descricao":"","features":[{"type":"Feature","properties":{"nome":"dawdw","descricao":"dawd"},"bbox":[-48.567086,-27.622952,-48.523846,-27.576918],"geometry":{"type":"Polygon","coordinates":[[[-48.567086,-27.585631],[-48.555193,-27.576918],[-48.529378,-27.588622],[-48.523846,-27.604096],[-48.533526,-27.621782],[-48.556391,-27.622952],[-48.56644,-27.617063],[-48.567086,-27.585631]]]},"id":"","descricao":""}]}',
          },
        },
      })
      alert('success', 'Camada salva com sucesso.')
      onCancel()
      refetch()
    } catch (error) {
      return handleRejection(error as ApolloError)
    }
  }

  const handleCancel = (form: PecFormApi<TerritorioMapaCamadasFormModel>) => {
    onCancel()
    form.reset()
  }

  return (
    <Form<TerritorioMapaCamadasFormModel>
      render={({ form, handleSubmit }) => (
        <Flow direction='vertical' style={styles.root}>
          <Flow direction='vertical'>
            <TextField name={meta.nome} label='Nome da Camada' required />
            <TextField name={meta.categoria} label='Categoria' required />
            <TextAreaField name={meta.descricao} label='Descrição' required maxLength={200} />
            <VisibilidadePoligonoTerritorioSelectField name={meta.visibilidade} label='Visibilidade' required />
          </Flow>
          <Flow direction='vertical' gap={0.5}>
            <SubmitButton handleSubmit={handleSubmit} size='medium'>
              Salvar
            </SubmitButton>
            <Button skin='outline' size='small' block onClick={() => handleCancel(form)}>
              Cancelar
            </Button>
          </Flow>
        </Flow>
      )}
      onSubmit={handleSubmit}
      validate={validateTerritorioMapaCamadasForm}
    />
  )
}

const styles = {
  root: css`
    padding-top: 0.5rem;
    height: 100%;
    align-content: space-between;
  `,
}
